import { useFormikContext } from 'formik'

import { Divider } from '../../../../../../Divider'
import { FormFieldsContainer } from '../../../../../../Form'
import {
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_NON_REGISTERED_USERS_CHECKBOX,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS_CHECKBOX,
} from '../../RecipientsField.constants'

import { AudienceCheckboxFields } from './AudienceCheckboxFields'
import { BuildingFields } from './BuildingFields'
import { BuildingGroupFields } from './BuildingGroupFields'
import {
  isActiveBuildingBlock,
  showBuildingTab,
} from './CustomizeRecipientAudienceFormFields.utils'
import { NonRegisteredUsersFields } from './NonRegisteredUsersFields'
import { RecipientAudienceRadioFields } from './RecipientAudienceRadioFields'
import { RecipientInfoStatus } from './RecipientInfoStatus'
import { RegisteredUsersFields } from './RegisteredUsersFields'

import * as styles from '../CustomizeRecipientAudienceModal.module.css'

function CustomizeRecipientAudienceFormFields({ isStaffUserAcc, ticker }) {
  const { values } = useFormikContext()

  const buildingBlock = showBuildingTab(values)

  const activeBuildingBlock = isActiveBuildingBlock(values) || !isStaffUserAcc

  const activePersonalStatus =
    values[
      NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_NON_REGISTERED_USERS_CHECKBOX
    ] ||
    values[NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_REGISTERED_USERS_CHECKBOX]

  const divider = <Divider className={styles.divider} />

  return (
    <FormFieldsContainer>
      {isStaffUserAcc ? (
        <>
          <div className={styles.audienceContainer}>
            {!ticker ? (
              <>
                <RegisteredUsersFields />
                <NonRegisteredUsersFields />
              </>
            ) : null}
            <AudienceCheckboxFields ticker={ticker} />
          </div>

          {divider}
          <RecipientInfoStatus disabled={!activePersonalStatus} />
          {divider}
        </>
      ) : null}
      <div className={styles.audienceContainer}>
        <RecipientAudienceRadioFields
          disabled={!activeBuildingBlock}
          isStaffUserAcc={isStaffUserAcc}
        />
        {buildingBlock ? (
          <BuildingFields disabled={!activeBuildingBlock} />
        ) : (
          <BuildingGroupFields disabled={!activeBuildingBlock} />
        )}
      </div>
    </FormFieldsContainer>
  )
}

export default CustomizeRecipientAudienceFormFields
